import React, { useState, useEffect } from 'react';
// import UserVenteListTable from './UserVenteListTable';
import VenteListCard from '../vente_list/VenteListCard';
import { getSocietes } from '../../flux/actions/societeActions';
import { getUsers } from '../../flux/actions/userActions';
import { getSummaryProject, clearVentes } from '../../flux/actions/venteActions';
import { getSummaryProjectAssociations, clearAssociations } from '../../flux/actions/associationActions';
import { Container, Row, Col, Label, CustomInput, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { connect } from 'react-redux';
import { VenteSummaryProjectContainer, IVenteSummaryProjectReduxProps } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import { E_ERROR } from '../../types/errors';
import { PRIVILEGE } from '../../types/privileges'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faHouseUser, faMoneyBill, faMoneyCheckAlt, faWallet, faFunnelDollar, faBalanceScaleLeft, faExclamationTriangle, faUsers, faUserLock, faQuestionCircle, faSquare, faStore, faBuilding, faFileSignature, faChevronCircleDown, faTh, faExpandArrowsAlt, faChartBar, faThLarge, faListOl, faCircle } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import Durations from '../Durations';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';
import Loading from '../Loading';
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import { Bar } from 'react-chartjs-2';

const VenteSummaryProjectContainerComponent = ({
  getSocietes,
  getUsers,
  getSummaryProject,
  clearVentes,
  getSummaryProjectAssociations,
  clearAssociations,
  societe,
  user,
  vente,
  association,
  auth
 }: VenteSummaryProjectContainer) => {
  const history = useHistory();
  const alert = useAlert();

  const { users, loading: loadingU } = user;
  const { societes, loading: loadingS } = societe;
  const { ventes, loading } = vente;
  const { associations, loading: loadingA } = association;
  const [ventesAndAssociations, setVentesAndAssociations] = useState<any[]>([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
    if(!a.createdAt && !b.createdAt)
      return 0
    else if(!a.createdAt)
      return 1
    else if(!b.createdAt)
      return -1
    else
      return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  }));
  const [tableData, setTableData] = useState(ventesAndAssociations);
  const [filteredRows, setFilteredRows] = useState(ventesAndAssociations);
  const selectOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const [selectedValue, setSelectedValue] = useState<any>('');
  // const userOptions = users.map(e => ({value: e, label: e.username}));
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? [{id: "ALL", LOGIN: "Tout"}, ...users.map(e => ({id: e.id, LOGIN: e.username}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username}]).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));
  // const userOptions = [...(auth?.user?.underlings?.filter(e => e.id !== auth.user.id).length ? [{id: "ALL", LOGIN: "Tout"}] : []), {id: auth?.user?.id, LOGIN: auth?.user?.username}, ...(auth?.user?.underlings?.filter(e => e.id !== auth.user.id) || [])].map(e => ({value: e.id, label: e["LOGIN"], user: e}));
  const [selectedUser, setSelectedUser] = useState<any>('');
  const titledOptions = [{value: "ALL", label: "Tout"}, {value: "TITLED", label: "Titrés"}, {value: "UNTITLED", label: "Non titrés"}];
  const [titledValue, setTitledValue] = useState<any>(titledOptions.find(e => e.value === "ALL"));
  const sNotaireOptions = [{value: "NOT YET", label: "Pas encore signé"}, {value: "CHEZ", label: "Signé client"}, {value: "EN COURS", label: "Signature en cours"}, {value: "SIGNE", label: "Signé notaire"}];
  const [sNotaireValues, setSNotaireValues] = useState<any[]>(sNotaireOptions.filter(e => ["NOT YET", "CHEZ", "EN COURS", "SIGNE"].includes(e.value)));
  const [selectedDuration, setSelectedDuration] = useState('');
  // const [showAllAssociationsValue, setShowAllAssociationsValue] = useState(true);
  const [calculateParts, setCalculateParts] = useState(false);
  // const [includeSigneNotaire, setIncludeSigneNotaire] = useState(false);
  const [aaa, setAaa] = useState(4);
  const ventesByProject = societes.filter(e => e.LIBELE !== "CM3" && e.LIBELE !== "CM3 SOCIAL").map(e => ({projectName: e.LIBELE, projectId: e.id, projectVentes: ventesAndAssociations.filter(t => (t.isAssLine ? t.contrat : t)?.PROJET === e.LIBELE)})).filter(e => !!e.projectVentes?.length);
  // const [ventesByProject, setVentesByProject] = useState<any[]>([]);
  const [moreCountDetailsVisible, setMoreCountDetailsVisible] = useState<any>({});

  const [chartModal, setChartModal] = useState(false);
  const [chartModalVentes, setChartModalVentes] = useState<any[]>([]);
  const [labels, setLabels] = useState<any[]>([]);
  const xAxisOptions = [/*{value: "30 DAYS", label: "30 jours"}, */{value: "3 MONTHS", label: "3 mois"}, {value: "6 MONTHS", label: "6 mois"}, {value: "1 YEAR", label: "Cet an"}, {value: "2 YEARS", label: "2 ans"}, {value: "3 YEARS", label: "3 ans"}/*, {value: "MAX", label: "Maximum"}*/];
  const [xAxisValue, setXAxisValue] = useState<any>(xAxisOptions.find(e => e.value === "6 MONTHS"));
  const yAxisOptions = [/*{value: "sCount", label: "Nombre de ventes"}, */{value: "sPrixNet", label: "Prix Net"}, {value: "sEncaissements", label: "Encaissements"}, {value: "sEncaissementsReceptionnes", label: "Encaissements réceptionnés"}, {value: "sReliquat", label: "Reliquat"}];
  const [yAxisValues, setYAxisValues] = useState(yAxisOptions.filter(e => ["sPrixNet", "sEncaissements"].includes(e.value)));
  const chartOptions = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    animation: {
      duration: 0
    }
  };
  const chartModalOptions = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    }
  };

  useEffect(() => {
    const labelsdata: any[] = [];
    const today = {month: new Date().getMonth() + 1, year: new Date().getFullYear()};

    const populateFromI = (i) => {
      let year = today.year;
      let month = i;
      if(i <= 0){
        const yearsDifference = Math.floor((i - 1) / 12) * -1;
        year -= yearsDifference;
        month = i + 12 * yearsDifference
      }
      labelsdata.push({month, year})
    }
    
    if(["30 DAYS", "3 MONTHS", "6 MONTHS"].includes(xAxisValue?.value)){
      let monthCount = 6;
      switch(xAxisValue?.value){
        case "30 DAYS": monthCount = 1; break;
        case "3 MONTHS": monthCount = 3; break;
        case "6 MONTHS": monthCount = 6; break;
      }
      // for(let i = today.month; i > today.month - monthCount; i--)
      for(let i = today.month - monthCount + 1; i <= today.month; i++)
        populateFromI(i)
    }
    else if(["1 YEAR", "2 YEARS", "3 YEARS"].includes(xAxisValue?.value)){
      let yearCount = 1;
      switch(xAxisValue?.value){
        case "1 YEAR": yearCount = 1; break;
        case "2 YEARS": yearCount = 2; break;
        case "3 YEARS": yearCount = 3; break;
      }
      for(let i = 1 - (12 * (yearCount - 1)); i <= today.month; i++)
        populateFromI(i)
    }

    const isSameYear = labelsdata.every((v, i, a) => i === 0 || v.year === a[i - 1].year);
    setLabels(labelsdata.map(e => ({...e, label: `${constants.MONTHS_ABBRV[Number(e.month) - 1]}${isSameYear ? "" : ` ${e.year.toString().slice(-2)}`}`})));
  }, [xAxisValue]);

  const getVentesFromMonth0 = (ventes, month, year) => {
    return ventes.map(e => (calculateParts && e.TYPE_VENTE === "ASSOCIATION") ? {...e, associations: e.associations.filter(e => e.createdAt && (new Date(e.createdAt).getMonth() + 1) === month && (new Date(e.createdAt).getFullYear()) === year)} : e).filter(e => {
      return (calculateParts && e.TYPE_VENTE === "ASSOCIATION") || (e.createdAt && (new Date(e.createdAt).getMonth() + 1) === month && (new Date(e.createdAt).getFullYear()) === year)
    })
  }

  const getVentesFromMonth = (ventesAndAssociations, month, year) => {
    return ventesAndAssociations.filter(e => {
      const createdAt = e.isAssLine ? e.originalDate : e.DATE_RESERV;
      return createdAt && (new Date(createdAt).getMonth() + 1) === month && (new Date(createdAt).getFullYear()) === year
    })
  }

  const handleToggleChart = () => setChartModal(!chartModal);

  const handleYAxisValuesChange = data => {
    setYAxisValues(data?.length ? data/*.map(e => e.value)*/ : []);
  }

  // const changeShowAllAssociationsHandle = (e) => {
  //   setShowAllAssociationsValue(e.target.checked);
  //   if(e.target.checked)
  //     setSelectedDuration('')
  // };

  const changeCalculatePartsHandle = (e) => {
    setCalculateParts(e.target.checked);
    // if(e.target.checked)
    //   setSelectedDuration('')
  };

  // const changeIncludeSigneNotaireHandle = (e) => {
  //   setIncludeSigneNotaire(e.target.checked);
  // };

  useEffect(() => console.log("selectedUser", selectedUser), [selectedUser])

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  useEffect(() => {
    if(auth?.user?.id !== undefined && selectedUser === '')
      setSelectedUser(userOptions.find(e => e.value === (auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? "ALL" : auth.user.id))?.user || '')
  }, [auth?.user?.id, auth?.user?.underlings]);

  // useEffect(() => {
  //   if(societes && societes.length){
  //     if(auth && auth.user){
  //       for(let so of societes)
  //         if(so.id == auth.user.last_societe){
  //           setSelectedValue(so);
  //           break
  //         }
  //     }
  //   }
  // }, [societes]);

  useEffect(() => {
    clearVentes();
    clearAssociations();
    if(auth?.user && selectedUser && (!auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) || users?.length)){
      getSummaryProject(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], selectedUser.id === "ALL" && !!auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? 1 : 0, (titledValue || titledOptions[1]).value, calculateParts ? 1 : 0, auth?.user.societes || []);
      // getSummaryProject(selectedDuration, auth.user.id || -1, selectedValue["id"] === "ALL" ? "ALL" : selectedValue["id"], selectedValue["LIBELE"], auth?.user.societes || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
      if(calculateParts)
        getSummaryProjectAssociations(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], selectedUser.id === "ALL" && !!auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? 1 : 0, (titledValue || titledOptions[1]).value, auth?.user.societes || []);
    }
  }, [/*getSummaryProject, */auth, selectedDuration, calculateParts, titledValue, selectedUser/*, includeSigneNotaire*/, users]);

  useEffect(() => {
    return () => {
      clearVentes();
      clearAssociations();
    }
  }, []);

  useEffect(() => {
    setVentesAndAssociations([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))]
    .filter(e => sNotaireValues.some(e => e.value === "NOT YET") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !!(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !!(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "CHEZ") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || (e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "EN COURS") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]))
    .filter(e => sNotaireValues.some(e => e.value === "SIGNE") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      // .filter(e => includeSigneNotaire || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      .filter(e => (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3" && (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3 SOCIAL")
      .sort((a, b) => {
      if(!a.createdAt && !b.createdAt)
        return 0
      else if(!a.createdAt)
        return 1
      else if(!b.createdAt)
        return -1
      else
        return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
    }))
  }, [ventes, associations, sNotaireValues]);

  useEffect(() => {
    setTableData(ventesAndAssociations);
  }, [ventesAndAssociations]);

  // useEffect(() => {console.log("ventes", ventes)
  //   const associationVentes = ventes.filter(e => e.TYPE_VENTE === "ASSOCIATION");
  //   const lines: any[] = ventes.filter(e => e.TYPE_VENTE !== "ASSOCIATION");
  //   for(let i in associationVentes){
  //     const associations = associationVentes[i].associations || [];
  //     for(let j in associations)
  //       lines.push({...associations[j], vente: associationVentes[i], isAssLine: true})
  //   }
  //   setTableData((showAllAssociationsValue ? lines : [...ventes]).sort((a, b) => {
  //     if(!a.createdAt && !b.createdAt)
  //       return 0
  //     else if(!a.createdAt)
  //       return 1
  //     else if(!b.createdAt)
  //       return -1
  //     else
  //       return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  //   }));
  // }, [ventes, showAllAssociationsValue]);

  useEffect(() => console.log("tableData", tableData), [tableData])
  
  const handleSelectChange = data => {
    setSelectedValue(data ? data.value : '');
  }
  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }
  const handleTitledChange = data => {
    setTitledValue(data || '');
  }
  const handleSNotaireChange = data => {
    setSNotaireValues(data?.length ? data : []);
  }
  const handleAaaChange = e => {
    setAaa(e.target.value);
  }
  const handleXAxisChange = data => {
    setXAxisValue(data || '');
  }

  const filterOptions = (e, input) => {
    if(!e.value)
      return false;
    const filterWords = input.trim().split(' ');
    
    if(filterWords.length){
      let allWordsMatch = true;
      for(let word of filterWords){
        word = word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!e.value.LIBELE || !e.value.LIBELE.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(word))
          allWordsMatch = false
      }
      return allWordsMatch
    }
    
    return true;
  }
  
  const viewDetailsPage = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open(`/resume_charges/${id}`, '_blank');
        return;
      }
      history.push({ pathname: `/resume_charges/${id}` })
    }
    else
      alert.error(E_ERROR.NO_PROJECT_WITH_THIS_ID)
  }

  return (!auth?.user) ? <LoadingPage/> : (
    <>
      <Container>
        <Row>
          <Col xs="12" lg="6"><h3 className="title"><FontAwesomeIcon icon={faTh} />&nbsp;&nbsp;Récap par Projet</h3></Col>
          <Col xs="12" lg="6" className="fullFlexCenter justify-content-center justify-content-lg-end">
            <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Ne prendre en compte que les parts vendues si association" checked={calculateParts} onChange={changeCalculatePartsHandle} />
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg="4" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="user">Chargé du bien : </Label>
            </div>
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
              onChange={handleUserChange}
              placeholder={'Chercher par nom...'}
              isClearable={true}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
          <Col sm="12" lg="5" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="snotaire">Statut notaire : </Label>
            </div>
            <Select
              id="snotaire"
              className="reactselect"
              classNamePrefix="react-select"
              isMulti
              value={sNotaireValues?.map(e => ({label: e.label, value: e.value})) || []}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleSNotaireChange}
              placeholder={'Chercher...'}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              options={sNotaireOptions}
              menuContainerStyle={{ zIndex: 9999999 }}
            />
          </Col>
          <Col xs="12" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="titled">Titrés : </Label>
            </div>
            <Select
              id="titled"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={titledOptions[1]}
              value={titledValue}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleTitledChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={titledOptions}
            />
          </Col>
          {/* <input type="text" onChange={handleAaaChange} value={aaa} /> */}
          {/* <Col xs="12" lg="3" className="fullFlexCenter justify-content-center justify-content-lg-end">
            <CustomInput type="switch" id="includeSigneNotaire" name="includeSigneNotaireSwitch" label="Signés notaire inclus" checked={includeSigneNotaire} onChange={changeIncludeSigneNotaireHandle} />
          </Col> */}
        </Row>
      </Container>
      {/* <Container>
        <Row className="justify-content-center justify-content-sm-end">
          <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Ne prendre en compte que les parts vendues pour les associations" checked={showAllAssociationsValue} onChange={changeShowAllAssociationsHandle} />
        </Row>
      </Container> */}
      {loading || loadingA ? <Loading topSpace /> : <Container className="mt-4">
        <Row className="justify-content-center">
          {ventesByProject.length ? ventesByProject.map(e => ({
              ...e,
              // sPrixNet: e.projectVentes.reduce((e, t) => e + ((!calculateParts || t.TYPE_VENTE !== "ASSOCIATION" ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)) || 0), 0),
              // sEncaissements: e.projectVentes.reduce((e, t) => e + (t.contrat_encaissements?.filter(e => !calculateParts || t.TYPE_VENTE !== "ASSOCIATION" || (t.associations || []).map(t => t.id?.toString()).includes(e.ID_ASS))?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0),
              // sEncaissementsReceptionnes: e.projectVentes.reduce((e, t) => e + (t.contrat_encaissements?.filter(e => !calculateParts || t.TYPE_VENTE !== "ASSOCIATION" || (t.associations || []).map(t => t.id?.toString()).includes(e.ID_ASS))?.reduce((e, t) => e + (t.encaissement?.STATUT && [constants.STATUT_ENC_PTF, constants.STATUT_ENC_OLD_VERSEMENT, constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_IMPAYE].includes(t.encaissement.STATUT) && t.PART ? t.PART : 0), 0) || 0), 0)
              sPrixNet: e.projectVentes.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
              sEncaissements: e.projectVentes.reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0),
              sEncaissementsReceptionnes: e.projectVentes.reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.encaissement?.STATUT && [constants.STATUT_ENC_PTF, constants.STATUT_ENC_OLD_VERSEMENT, constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_REPRESENTE, constants.STATUT_ENC_NOTAIRE].includes(t.encaissement.STATUT) && t.PART ? t.PART : 0), 0) || 0), 0)
            })).map(e => ({...e, sReliquat: e.sPrixNet - e.sEncaissements})).sort((a, b) => b.sReliquat - a.sReliquat).map((e, key) => <Col xs="12" lg=/*"4"{aaa}*/{ventesByProject.length === 1 ? 6 : 4} key={key}>
            <Container className="CardInfo resumeCard">
              <Row className="resumeCardTitle title">
                {e.projectName}
              </Row>
              <Row>
                <Col xs="12" sm="12" className="resumeCardText">
                  <FontAwesomeIcon icon={faFileSignature} />&nbsp;<strong>Biens{e.projectVentes.filter(e => e.isAssLine).length ? " (et parts)" : ""} vendus : </strong>
                </Col>
                <Col xs="12" sm="12" className="resumeCardText">
                  {e.projectVentes.length} <FontAwesomeIcon icon={faChevronCircleDown} title="Plus de détails" className="bienCountMoreDetails" style={moreCountDetailsVisible[e.projectId] ? {transform: "rotate(-180deg)"} : {}} onClick={() => setMoreCountDetailsVisible({...moreCountDetailsVisible, [e.projectId]: !moreCountDetailsVisible[e.projectId]})} />
                </Col>
              </Row>
              {/* <Row>
                <Col xs="12" style={{textAlign: "center"}}>
                  <h3>{e.projectVentes.length} biens vendus</h3>
                </Col>
              </Row> */}
              {moreCountDetailsVisible[e.projectId] ? <>
              <Row className="justify-content-around fadeAnimation" style={{border: "1px solid #62af42", borderRadius: "10px", marginBottom: "2px"}}>
                <Col xs="12" sm="6" className="border-0 text-center">
                  <FontAwesomeIcon icon={faSquare} />&nbsp;<strong>Lots : </strong>{e.projectVentes.filter(e => !e.isAssLine && e.TYPE && (e.TYPE.toUpperCase().includes("+") || e.TYPE.toUpperCase().includes(constants.VILLA) || e.TYPE.toUpperCase().includes(constants.EQUIPEMENT))).length}
                </Col>
                <Col xs="12" sm="6" className="border-0 text-center">
                  <FontAwesomeIcon icon={faStore} />&nbsp;<strong>Magasins : </strong>{e.projectVentes.filter(e => !e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("MAG")).length}
                </Col>
                <Col xs="12" sm={e.projectVentes.filter(e => !e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG") && !e.TYPE.toUpperCase().includes("+") && !e.TYPE.toUpperCase().includes(constants.VILLA) && !e.TYPE.toUpperCase().includes(constants.EQUIPEMENT)))).length ? "6" : "12"} className="border-0 text-center">
                  <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Appartements : </strong>{e.projectVentes.filter(e => !e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("APP")).length}
                </Col>
                {e.projectVentes.filter(e => !e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG") && !e.TYPE.toUpperCase().includes("+") && !e.TYPE.toUpperCase().includes(constants.VILLA) && !e.TYPE.toUpperCase().includes(constants.EQUIPEMENT)))).length ? <Col xs="12" sm="6" className="border-0 text-center">
                  <FontAwesomeIcon icon={faQuestionCircle} />&nbsp;<strong>Inconnus : </strong>{e.projectVentes.filter(e => !e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG") && !e.TYPE.toUpperCase().includes("+") && !e.TYPE.toUpperCase().includes(constants.VILLA) && !e.TYPE.toUpperCase().includes(constants.EQUIPEMENT)))).length}
                </Col> : null}
              </Row>
              {calculateParts ? <Row className="justify-content-around fadeAnimation" style={{border: "1px solid #62af42", borderRadius: "10px", marginBottom: "2px"}}>
                <Col xs="12" sm={e.projectVentes.filter(e => e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG")))).length > 0 ? "12" : "12"} className="border-0 text-center assoCardColor">
                  <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Appartements (Association) : </strong>{e.projectVentes.filter(e => e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("APP")).length}
                </Col>
                <Col xs="12" sm={e.projectVentes.filter(e => e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG")))).length > 0 ? "12" : "12"} className="border-0 text-center assoCardColor">
                  <FontAwesomeIcon icon={faStore} />&nbsp;<strong>Magasins (Association) : </strong>{e.projectVentes.filter(e => e.isAssLine && e.TYPE && e.TYPE.toUpperCase().includes("MAG")).length}
                </Col>
                {e.projectVentes.filter(e => e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG")))).length ? <Col xs="12" className="border-0 text-center assoCardColor">
                  <FontAwesomeIcon icon={faQuestionCircle} />&nbsp;<strong>Inconnus (Association) : </strong>{e.projectVentes.filter(e => e.isAssLine && (!e.TYPE || (!e.TYPE.toUpperCase().includes("APP") && !e.TYPE.toUpperCase().includes("MAG")))).length}
                </Col> : null}
              </Row> : null}
              <Row className="fadeAnimation" style={{border: "1px solid #62af42", borderRadius: "10px", marginBottom: "2px"}}>
                <Col xs="12" className="border-0 text-center">
                  <FontAwesomeIcon icon={faUserLock} />&nbsp;<strong>Ventes normales : </strong>{e.projectVentes.filter(e => e.TYPE_VENTE === "UNIQUE").length}
                </Col>
                <Col xs="12" className="border-0 text-center">
                  <FontAwesomeIcon icon={faUsers} />&nbsp;<strong>Associations : </strong>{e.projectVentes.filter(e => e.TYPE_VENTE === "ASSOCIATION").length}
                </Col>
                {e.projectVentes.filter(e => e.isAssLine).length ? <Col xs="12" className="border-0 text-center assoCardColor">
                  <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Parts d'association : </strong>{e.projectVentes.filter(e => e.isAssLine).length}
                </Col> : null}
              </Row>
              <Row className="fadeAnimation" style={{border: "1px solid #62af42", borderRadius: "10px", fontSize: "small"}}>
                {e.projectVentes.map(e => e.TYPE).filter((e, i, a) => i === 0 || a.indexOf(e) === i).map((t, key) => <Col xs="12" sm="6" className="border-0 text-center" key={key}>
                  <FontAwesomeIcon icon={faCircle} />&nbsp;<strong>{t} : </strong>{e.projectVentes.filter(e => e.TYPE === t).length}
                </Col>)}
              </Row>
              </> : null}
              <Row>
                <Col xs="12" sm="12" className="resumeCardText">
                  <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Somme des prix net : </strong>
                </Col>
                <Col xs="12" sm="12" className="resumeCardText">
                  {e.sPrixNet.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
                  
                  {/* &nbsp;{e.projectVentes.filter(e => !e.PRIX_NET).length ? <FontAwesomeIcon icon={faExclamationTriangle} style={{color: "orangered", cursor: "help"}} data-tip data-for={`ventesWithNoPrice${e.projectId}`} /> : null}
                  {e.projectVentes.filter(e => !e.PRIX_NET).length ? <ReactTooltip effect="solid" id={`ventesWithNoPrice${e.projectId}`} type={"dark"}>
                    {e.projectVentes.filter(e => !e.PRIX_NET).length} vente{e.projectVentes.filter(e => !e.PRIX_NET).length > 1 ? "s" : ""} sans Prix Net
                  </ReactTooltip> : null} */}

                  &nbsp;{e.projectVentes.filter(e => e.isAssLine ? !e.PRIX_VENTE : !e.PRIX_NET).length ? <FontAwesomeIcon icon={faExclamationTriangle} style={{color: "orangered", cursor: "help"}} data-tip data-for={`ventesWithNoPrice${e.projectId}`} /> : null}
                  {e.projectVentes.filter(e => e.isAssLine ? !e.PRIX_VENTE : !e.PRIX_NET).length ? <ReactTooltip effect="solid" id={`ventesWithNoPrice${e.projectId}`} type={"dark"}>
                    {e.projectVentes.filter(e => !e.isAssLine && !e.PRIX_NET).length ? `${e.projectVentes.filter(e => !e.isAssLine && !e.PRIX_NET).length} vente${e.projectVentes.filter(e => !e.isAssLine && !e.PRIX_NET).length > 1 ? "s" : ""} sans Prix Net` : ""}<br/>
                    {e.projectVentes.filter(e => e.isAssLine && !e.PRIX_VENTE).length ? `${e.projectVentes.filter(e => e.isAssLine && !e.PRIX_VENTE).length} part${e.projectVentes.filter(e => e.isAssLine && !e.PRIX_VENTE).length > 1 ? "s" : ""} sans Prix` : ""}
                  </ReactTooltip> : null}
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="12" className="resumeCardText">
                  <FontAwesomeIcon icon={faMoneyCheckAlt} />&nbsp;<strong>Somme des encaissements : </strong>
                </Col>
                <Col xs="12" sm="12" className="resumeCardText">
                  {e.sEncaissements.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH {e.sEncaissements && e.sPrixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((e.sEncaissements * 100) / e.sPrixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((e.sEncaissements * 100) / e.sPrixNet)}%)</span> : null}
                </Col>
              </Row>
              {/* <Row>
                <Col xs="12" sm="12" className="resumeCardText">
                  <FontAwesomeIcon icon={faWallet} />&nbsp;<strong>Encaissements réceptionnés : </strong>
                </Col>
                <Col xs="12" sm="12" className="resumeCardText">
                  {e.sEncaissementsReceptionnes.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
                </Col>
              </Row> */}
              <Row>
                <Col xs="12" sm="12" className="resumeCardText">
                  <FontAwesomeIcon icon={faBalanceScaleLeft} />&nbsp;<strong>Reliquat : </strong>
                </Col>
                <Col xs="12" sm="12" className="resumeCardText">
                  {e.sReliquat.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH
                </Col>
              </Row>
              {auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? <div className="fullFlexCenter">
                <span className="divSpanAsLinkContent" style={{fontSize: "small", color: "dodgerblue"}} onClick={t => viewDetailsPage(t, e.projectId)} title="Plus de détails (CTRL+Clic pour l'ouvrir dans une nouvelle page)"><FontAwesomeIcon icon={faListOl} />&nbsp;<span>Plus de détails</span></span>
              </div> : null}
              <Row style={{position: "relative"}}>
                <FontAwesomeIcon icon={faExpandArrowsAlt} className="chartFullScreenIcon" title="Agrandir" onClick={() => {setChartModalVentes(e.projectVentes); setChartModal(true)}} />
                <Bar data={{
                  labels: labels.map(e => e.label),
                  datasets: [
                    // ...(yAxisValues.find(e => e.value === "sCount") ? [{
                    //   label: '# Ventes',
                    //   data: labels.map(t => getVentesFromMonth(e.projectVentes, t.month, t.year).length),
                    //   backgroundColor: 'rebeccapurple',
                    // }] : []),
                    ...(yAxisValues.find(e => e.value === "sPrixNet") ? [{
                      label: 'Σ Vendue',
                      data: labels.map(t => getVentesFromMonth(e.projectVentes, t.month, t.year).reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0)),
                      backgroundColor: 'cornflowerblue',
                    }] : []),
                    ...(yAxisValues.find(e => e.value === "sEncaissements") ? [{
                      label: 'Σ Encaissée',
                      data: labels.map(t => getVentesFromMonth(e.projectVentes, t.month, t.year).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0)),
                      backgroundColor: 'green',
                    }] : []),
                    ...(yAxisValues.find(e => e.value === "sEncaissementsReceptionnes") ? [{
                      label: 'Σ Réceptionnée',
                      data: labels.map(t => getVentesFromMonth(e.projectVentes, t.month, t.year).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.encaissement?.STATUT && [constants.STATUT_ENC_PTF, constants.STATUT_ENC_OLD_VERSEMENT, constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_REPRESENTE, constants.STATUT_ENC_NOTAIRE].includes(t.encaissement.STATUT) && t.PART ? t.PART : 0), 0) || 0), 0)),
                      backgroundColor: 'lime',
                    }] : []),
                    ...(yAxisValues.find(e => e.value === "sReliquat") ? [{
                      label: 'Σ Reliquat',
                      data: labels.map(t => (getVentesFromMonth(e.projectVentes, t.month, t.year).reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) || 0) - (getVentesFromMonth(e.projectVentes, t.month, t.year).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0) || 0)),
                      backgroundColor: 'red',
                    }] : []),
                  ],
                }} options={chartOptions} />
              </Row>
            </Container>
          </Col>) : <div className="summaryNoData fullFlexCenter">{!selectedUser ? "Veuillez sélectionner un commercial" : "Aucun bien vendu"}</div>}
        </Row>
      </Container>}
      {loading || loadingA ? null : ventesByProject.length > 1 ? <VenteListCard allRows={ventesAndAssociations} filteredRows={ventesAndAssociations} selectedProjet={{id: "ALL"}} /*calculateParts={calculateParts}*/ hideFilterSwitch={true} hideER={true} hideCommission={true} flagFlag={true} /> : null}
      {/* <Container style={{marginTop: "2px"}}>
        <Row className="justify-content-center justify-content-sm-end">
          <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Afficher les parts des associations" checked={showAllAssociationsValue} onChange={changeShowAllAssociationsHandle} />
        </Row>
      </Container> */}
      {/* <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: "2px", ...(showAllAssociationsValue ? {opacity: .3, pointerEvents: "none"} : {})}} /> */}
      {/* <UserVenteListTable ventesData={tableData} setFilteredRows={setFilteredRows} showProjectColumn={selectedValue?.id === "ALL"} showComColumn={selectedUser?.id === "ALL"} showTitledColumn={titledValue?.value === "ALL"} allAssociationsShown={showAllAssociationsValue} /> */}
      {/* <VenteListCard allRows={ventes} filteredRows={filteredRows} selectedProjet={selectedValue} /> */}
      <Modal isOpen={chartModal} toggle={handleToggleChart} className="modal-dialog-large">
        <ModalHeader toggle={handleToggleChart}><FontAwesomeIcon icon={faChartBar} />&nbsp;&nbsp;-</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row className="justify-content-center">
                <Col xs="12" md="9" className="listPageFilterSelect">
                  <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
                    <Label for="yaxis">Données affichées : </Label>
                  </div>
                  <Select
                    id="yaxis"
                    className="reactselect"
                    classNamePrefix="react-select"
                    isMulti
                    value={yAxisValues || []}
                    onChange={handleYAxisValuesChange}
                    placeholder={'Chercher...'}
                    isClearable={true}
                    // isLoading={loadingS}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={true}
                    // labelKey='LIBELE'
                    options={yAxisOptions}
                    menuContainerStyle={{ zIndex: 9999999 }} />
                </Col>
                <Col xs="12" md="3" className="listPageFilterSelect">
                  <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
                    <Label for="xaxis">Durée : </Label>
                  </div>
                  <Select
                    id="xaxis"
                    className="reactselect"
                    classNamePrefix="react-select"
                    defaultValue={xAxisOptions.find(e => e.value === "6 MONTHS")}
                    value={xAxisValue}
                    // value={{value: societeValue.value, label: societeValue.label}}
                    onChange={handleXAxisChange}
                    isClearable={false}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={false}
                    options={xAxisOptions}
                  />
                </Col>
              </Row>
              <Row>
                <Bar data={{
                  labels: labels.map(e => e.label),
                  datasets: [
                    ...(yAxisValues.find(e => e.value === "sPrixNet") ? [{
                      label: 'Σ Vendue',
                      data: labels.map(t => getVentesFromMonth(chartModalVentes, t.month, t.year).reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0)),
                      backgroundColor: 'cornflowerblue',
                    }] : []),
                    ...(yAxisValues.find(e => e.value === "sEncaissements") ? [{
                      label: 'Σ Encaissée',
                      data: labels.map(t => getVentesFromMonth(chartModalVentes, t.month, t.year).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0)),
                      backgroundColor: 'green',
                    }] : []),
                    ...(yAxisValues.find(e => e.value === "sEncaissementsReceptionnes") ? [{
                      label: 'Σ Réceptionnée',
                      data: labels.map(t => getVentesFromMonth(chartModalVentes, t.month, t.year).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.encaissement?.STATUT && [constants.STATUT_ENC_PTF, constants.STATUT_ENC_OLD_VERSEMENT, constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_REPRESENTE, constants.STATUT_ENC_NOTAIRE].includes(t.encaissement.STATUT) && t.PART ? t.PART : 0), 0) || 0), 0)),
                      backgroundColor: 'lime',
                    }] : []),
                    ...(yAxisValues.find(e => e.value === "sReliquat") ? [{
                      label: 'Σ Reliquat',
                      data: labels.map(t => (getVentesFromMonth(chartModalVentes, t.month, t.year).reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) || 0) - (getVentesFromMonth(chartModalVentes, t.month, t.year).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0) || 0)),
                      backgroundColor: 'red',
                    }] : []),
                  ],
                }} options={chartModalOptions} />
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: IVenteSummaryProjectReduxProps) => ({
  societe: state.societe,
  user: state.user,
  vente: state.vente,
  association: state.association,
  auth: state.auth
});

export default connect(mapStateToProps, { getSocietes, getUsers, getSummaryProject, clearVentes, getSummaryProjectAssociations, clearAssociations })(VenteSummaryProjectContainerComponent);
